import { COL_PRODUCT_COMPONENTS } from '../config/collections'
import { pb, PB_NO_CANCEL } from '../pocketbase'
import type { ProductComponentRecord } from '../types/records'

/** Комплектация продукта (спецификация) для показа в заявке. */
export async function loadProductBomRows(productId: string): Promise<ProductComponentRecord[]> {
  if (!productId) return []
  return pb.collection(COL_PRODUCT_COMPONENTS).getFullList<ProductComponentRecord>({
    filter: `product="${productId}"`,
    expand: 'consumable',
    sort: '+sort',
    ...PB_NO_CANCEL,
  })
}
